import { useCallback, useState } from "react"
import { retrieveLeaderboard, retrieveLeaderboardSummary } from "src/pages/admin/services/whitelistService"
import { LeaderboardEntry, LeaderboardSummary } from "./List"

const useLeaderboard = () => {

  const [records, setRecords] = useState<LeaderboardEntry[]>([])
  const [total, setTotal] = useState(0)
  const [summary, setSummary] = useState<LeaderboardSummary>()

  const retrieve = useCallback(async() => {
    try {
      const response = await retrieveLeaderboard(500)

      setRecords(response.data.items)
      setTotal(response.data.total || 0)

    } catch (error) {
      console.log("error: ", error)
      throw error
    }
  }, [])

  const retrieveSummary = useCallback(async() => {
    try {
      const response = await retrieveLeaderboardSummary()
      console.log("response: ", response)
      setSummary(response.data)
    } catch (error) {
      console.log("error: ", error)
      throw error
    }
  }, [])

  return {
    retrieve,
    records,
    total,
    retrieveSummary,
    summary
  }


}

export default useLeaderboard